import { ZScoreRingColors } from "./types";

export const zScoreRingColors: ZScoreRingColors = {
  profits: {
    gradient: ["#2bc5f2", "#19dcd1", "#0ceaae"],
    icon: "#29cdbb",
  },
  risk: {
    gradient: ["#4c18b3", "#5352D8", "#526BDD"],
  },
  service: {
    gradient: ["#6e0a83", "#d94097", "#f24196"],
    icon: "#734c9a",
  },
  balanced: {
    gradient: ["#46835e", "#7fce87", "#88c489"],
    icon: "#a2b88d",
  },
};
